const omnihubElem = document.getElementById("omni-hub-stock");

if (omnihubElem) {
  const intervalId = setInterval(() => {
    const elements = omnihubElem.getElementsByTagName("th");

    if (elements.length > 0) {
      for (const e of elements) {
        e.innerHTML = e.innerHTML.replace(/^NAILS INC NAGOYA/, "");
        e.innerHTML = e.innerHTML.replace(/^NAILS INC/, "");
      }
      // ポーリングを停止
      clearInterval(intervalId);
    }
  }, 500);  // 500msごとにチェック

} else {
  console.warn("Element with ID 'omni-hub-stock' not found.");
}

document.addEventListener('DOMContentLoaded', function () {
  const productAreas = document.querySelectorAll('.product-area');

  productAreas.forEach(function (productArea) {
    const mobileThumbLinks = productArea.querySelectorAll(
      '.product-area__mobile-thumbs .theme-gallery-thumb a'
    );

    const viewport = productArea.querySelector('.theme-viewport.swiper-container');

    if (!mobileThumbLinks.length || !viewport) return;

    function updateActiveThumbByIndex(activeIndex) {
      mobileThumbLinks.forEach(function (link, index) {
        link.classList.toggle('thumb-active', index === activeIndex);
      });
    }

    function updateActiveThumbByMediaId(mediaId) {
      if (!mediaId) return;

      mobileThumbLinks.forEach(function (link) {
        const thumb = link.closest('.theme-gallery-thumb');
        const thumbMediaId = thumb ? thumb.dataset.mediaId : null;

        link.classList.toggle('thumb-active', thumbMediaId === mediaId);
      });
    }

    function updateActiveThumbFromCurrentSlide() {
      const activeSlide = viewport.querySelector('.swiper-slide-active');
      const activeMediaId = activeSlide ? activeSlide.dataset.mediaId : null;

      if (activeMediaId) {
        updateActiveThumbByMediaId(activeMediaId);
        return;
      }

      const swiper = viewport.swiper;

      if (swiper) {
        const activeIndex =
          typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex;

        updateActiveThumbByIndex(activeIndex);
      }
    }

    mobileThumbLinks.forEach(function (link, index) {
      link.addEventListener('click', function (event) {
        event.preventDefault();

        const swiper = viewport.swiper;

        if (swiper && typeof swiper.slideTo === 'function') {
          swiper.slideTo(index);
          updateActiveThumbByIndex(index);

          setTimeout(updateActiveThumbFromCurrentSlide, 300);
        }
      });
    });

    const waitForSwiper = setInterval(function () {
      const swiper = viewport.swiper;

      if (!swiper) return;

      clearInterval(waitForSwiper);

      if (typeof swiper.on === 'function') {
        swiper.on('slideChange', function () {
          setTimeout(updateActiveThumbFromCurrentSlide, 0);
          setTimeout(updateActiveThumbFromCurrentSlide, 300);
        });

        swiper.on('transitionEnd', function () {
          updateActiveThumbFromCurrentSlide();
        });

        swiper.on('touchEnd', function () {
          setTimeout(updateActiveThumbFromCurrentSlide, 300);
        });
      }

      updateActiveThumbFromCurrentSlide();
    }, 100);
  });
});

// 再入荷通知ボタン（Back in Stock / Amp）
// 押したときに、同じフォームで選ばれている色（バリエーション）のIDを読み、アプリのフォームを開く
// ※theme.js が後から別の jQuery を読み込むため、jQuery のイベントではなくフォームの値を直接読む
(function () {
  if (window.__restockNotifyInitialized) return;
  window.__restockNotifyInitialized = true;

  function currentVariantId(button) {
    const form = button.closest('form');
    const idField = form ? form.querySelector('[name="id"]') : null;
    const value = idField && idField.value ? idField.value : button.getAttribute('data-variant-id');
    return parseInt(value, 10);
  }

  document.addEventListener('click', function (e) {
    const button = e.target.closest ? e.target.closest('[data-restock-notify]') : null;
    if (!button) return;

    e.preventDefault();

    const variantId = currentVariantId(button);
    const bis = window.BIS;

    if (bis && bis.popup && typeof bis.popup.show === 'function') {
      try {
        bis.popup.show({ variantId: variantId });
        return;
      } catch (err) {
        console.warn('[restock-notify] BIS.popup.show failed', err);
      }
    }

    // クイックビュー等、商品ページ以外ではアプリのフォームが使えないため商品ページへ移動する
    const productUrl = button.getAttribute('data-product-url');
    if (productUrl && window.location.pathname.indexOf('/products/') === -1) {
      window.location.href = productUrl + (variantId ? '?variant=' + variantId : '');
    }
  });
})();
